export const fetchFactureByNumber = async (nbrFact, selectedHotel, identifiant) => {


    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;


    try {
        // Make the API request
        const response = await fetch(`${apiUrl}/api/factures_table/check/${nbrFact}/${selectedHotel}/${identifiant}`,{
            headers: { 'Authorization': `Bearer ${token}`}, // Attach the token here
        });

        // Check if the response was successful (status code 2xx)
        if (!response.ok) {
            // If not, throw an error with the status and message
            const errorData = await response.json();
            throw new Error(`Error: ${response.status} - ${errorData.error || 'Unknown error'}`);
        }

        // Return the parsed JSON from the response (facture details)
        return await response.json(); 
    } catch (error) {
        // Log the error and rethrow with a descriptive message
        console.error('Error fetching existing bills:', error);
        throw new Error('Failed to fetch existing bills. ' + error.message);
    }
};
